import FacultyActionCard from "../_local/components/NewCards/FacultyActionCard";
import React from "react";


interface Faculty {
    FACULTY_IMAGE?: { selectedImage: string };
    FACULTY_NAME?: string;
    GENDER?: string;
    FACULTY_DESIGNATION?: string;
    FACULTY_SUBJECT?: string | string[]; // Subject can be a string or an array of strings
    FACULTY_QUALIFICATION?: string;
    FACULTY_EXPERIENCE?: string;
    FACULTY_MOBILE?: string;
    FACULTY_EMAIL?: string;
    // Add other properties of your faculty object if needed
}

const FacultiesPreview = () => {
    const facultiesData: Faculty[] = JSON.parse(sessionStorage.getItem("faculties")) || [];

    if (!facultiesData || facultiesData.length === 0) {
        return <p className="text-gray-500">No teacher information added yet.</p>;
    }

    return (
        <div className="grid grid-cols-4 gap-4 sm:grid-cols-1 md:grid-cols-1">
            {facultiesData.map((faculty, index) => (
                <FacultyActionCard
                    key={`faculty-preview-${index}`}
                    element={faculty}
                    // handleOpenDrawer={() => {}} // No operation in preview
                    // onDelete={() => {}} // No operation in preview
                    isError={false} // Default value for preview
                />
            ))}
        </div>
    );
};

export default FacultiesPreview;